export const style = (state: string = 'default', action: any): string => {
	switch (action.type) {
		case 'Style.Change':
			// console.log(state, action)
			return action.style
		default:
			return state
	}
}